import PropTypes from 'prop-types'

const QualityThresholdType = PropTypes.shape({
    thresholdCode: PropTypes.number, // Int
    listType: PropTypes.string, // Option[String]
    stationType: PropTypes.string, // Option[String]
    parameterCode: PropTypes.string, // Option[String]
    unit: PropTypes.string, // Option[String]
    station: PropTypes.number, // Option[Int]
    fraction: PropTypes.string, // Option[String]
    threshold1: PropTypes.number, // Option[Double]
    threshold2: PropTypes.number, // Option[Double]
    threshold3: PropTypes.number, // Option[Double]
    threshold4: PropTypes.number, // Option[Double]
    frType: PropTypes.number, // Option[Double]
    elementCode: PropTypes.string, // Option[String]
    seasonality: PropTypes.number, // Option[Double]
    fishCode: PropTypes.number, // Option[Int]
    calciumClass: PropTypes.number, // Option[Int]
    ph: PropTypes.number, // Option[Double],
    thresholdType: PropTypes.string, // Option[String]
    display: PropTypes.string, // Option[String]
    discriminant: PropTypes.string, // Option[String]
    isFromChild: PropTypes.bool, // Option[Boolean]
})

export { QualityThresholdType }